import { render, staticRenderFns } from "./Health.vue?vue&type=template&id=3ef794a4&scoped=true"
import script from "./Health.vue?vue&type=script&lang=js"
export * from "./Health.vue?vue&type=script&lang=js"
import style0 from "./Health.vue?vue&type=style&index=0&id=3ef794a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef794a4",
  null
  
)

export default component.exports